import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { CheckResponse } from "@/types";

export const getCheck = async (): Promise<CheckResponse> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.CHECK.GET,
    errorMessage: "Failed to load site configuration.",
  });
};
